import { ThemeProvider } from "@mui/material/styles";
import MaterialTable from "@material-table/core";
import _ from "lodash";
import React, { createRef, useEffect, useState } from "react";
import { log } from "../../Helper";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { Button } from "@deere/fuel-react";
import { documentsToDownload } from "../../utils/utils";

import { useUserInfo } from "../../common/user-context";
import { AuditTableData } from "./api";
import { AUDIT_PAGE_TEXT, theme } from "./utility/constant";
import MatTableHeader from "./tableHeader/materialTableHeader";
import AuditMaterialTable from "./auditMaterialTable/auditMaterialTable";

const tableRef = createRef();

const Orders = () => {
  const { userData } = useUserInfo();
  const authorities = userData.authorities;

  const [isLoading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      if (
        authorities &&
        (authorities.includes("ROLE_FULL_APPLICATION_ACCESS") ||
          authorities.includes("ROLE_COMPLIANCE_AUDIT_ACCESS"))
      ) {
        getTableData();
      } else {
        log("You do not have access to open this page");
      }
    }
  }, [userData]);

  const getTableData = async () => {
    setLoading(true);
    try {
      const response = await AuditTableData();
      setTableData(response.content[0]);

      if (response.content[0].length > 0) {
        for (let i = 0; i < response.content[0].length; i++) {
          const innerObj = response.content[0][i];
          delete innerObj.tableData;
        }

        const col = Object.keys(response.content[0][0])
          .filter(key => key !== 'dateAdjustmentDocLinks') // Exclude dateAdjustmentDocLinks column
          .map((key) => ({
            title: key.replace(/_/g, " ").toUpperCase(),
            field: key,
            headerStyle: {
              fontSize: "12px",
            },
            // render: rowData => {
            //   log('key-----', key);
            //   log('rowData-----', rowData);
            //   if (_.isEqual(key, 'SIGNED_TEXT')) {
            //     const displayedText = rowData.SIGNED_TEXT.slice(0,7)
            //     return(
            //         <Tooltip title={rowData.SIGNED_TEXT}>
            //             <span>{displayedText}..</span>
            //         </Tooltip>
            //     );
            //   }
            // }
            //   render: rowData => (
            //     <Tooltip title={rowData[key]} arrow>
            //         <span>
            //             {rowData[key].length > 200 ? `${rowData[key].substring(0, 20)}...` : rowData[key]}
            //         </span>
            //     </Tooltip>
            // )
          }));

        // Add download column
        col.push({
          title: "DOCS",
          field: "docs",
          headerStyle: {
            fontSize: "12px",
          },
          sorting: false,
          filtering: false,
          render: (rowData) => {
            const hasDocuments = rowData.dateAdjustmentDocLinks && rowData.dateAdjustmentDocLinks.length > 0;
            return hasDocuments ? (
              <Button
                onClick={() => documentsToDownload(rowData.dateAdjustmentDocLinks)}
                style={{ padding: '4px' }}
                variant={null}
              >
                <SaveAltRoundedIcon className="text-black cursor-pointer hover:text-blue-600" />
              </Button>
            ) : null;
          }
        });

        setColumns(col);

        // check whether values are all 0's and only one object is fetched from API.
        // make table data as null to show column names and 'no data found' message.
        if (response.content[0].length == 1) {
          let areAllZero = false;
          for (let i = 0; i < response.content[0].length; i++) {
            areAllZero = Object.values(response.content[0][i]).every(
              (value) => value === 0
            );
          }
          if (areAllZero) {
            setTableData(Array(0));
          }
        }
      }
    } catch (error) {
      log("Error occured when fetching data: ", error);
      setTableData(Array(0));
    }
    setLoading(false);
  };

  return (
    <div className="rounded-sm">
      <MatTableHeader
        getTableData={getTableData}
        headerText={AUDIT_PAGE_TEXT}
      />
      <ThemeProvider theme={theme}>
        {isLoading && <LoaderComponent />}
        {!isLoading && (
          <AuditMaterialTable
            tableName="Audit"
            tableRef={tableRef}
            columns={columns}
            tableData={tableData}
          />
        )}
      </ThemeProvider>
    </div>
  );
};
export default Orders;
